import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FooterMenu, {
	Footer as LithoFooter,
} from '../../Litho/Components/Footers/Footer';

const FooterData = [
	{
		title: 'Company',
		submenu: [
			{
				title: 'Home',
				link: '/',
			},
			{
				title: 'About company',
				link: '/about',
			},
			{
				title: 'Contact Us',
				link: '/contact',
			},
			{
				title: 'Track Shipment',
				link: '/track-shipment',
			},
		],
	},
	{
		title: 'Shipping',
		submenu: [
			{
				title: 'Air Freight',
				link: '/air-freight',
			},
			{
				title: 'Road Freight',
				link: '/road-freight',
			},
			{
				title: 'Ocean Freight',
				link: '/ocean-freight',
			},
		],
	},
];

const Footer = () => {
	return (
		<LithoFooter className='bg-slate-900 text-slate-300 border-t border-slate-800/50 pt-16 pb-8 xs:pt-12'>
			<Container>
				<Row className='items-start md:text-start gap-y-12'>
					<Col lg={{ span: 4, order: 0 }} md={6} sm={{ span: 12, order: 1 }}>
						<Link aria-label='home' to='/' className='inline-block'>
							<img
								className='w-[140px] md:w-[150px] my-2 filter'
								src='/assets/img/inter-logo.png'
								alt='logo'
								style={
									{
										// filter: 'drop-shadow(0px 0px 10px red) ',
									}
								}
							/>
						</Link>
						<p className='font-funnel font-normal lg:w-full sm:w-full text-sm leading-7 tracking-[0.2px] xs:w-[95%] text-start text-slate-400 mt-4'>
							INTERLINK OCEANA offers comprehensive ocean transportation
							services, supporting businesses across Hong Kong, China, Dubai and
							worldwide.
						</p>
					</Col>
					<FooterMenu
						className='justify-between ms-auto'
						data={FooterData}
						lg={{ span: 3, order: 0 }}
						sm={{ span: 6, order: 2 }}
						titleClass='text-sm !font-semibold !font-funnel tracking-[0.5px] text-slate-200'
					/>
				</Row>
				<Row className='mt-10 pt-6 border-t border-slate-800/40'>
					<Col>
						<p className='text-xs text-slate-500'>
							© {new Date().getFullYear()} Interlink Oceana. All rights
							reserved.
						</p>
					</Col>
				</Row>
			</Container>
		</LithoFooter>
	);
};

export default Footer;
